module.exports = __webpack_public_path__ + "img/illu-ocean.67c57f54.svg";